/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FieldPermissionData
 */
export interface FieldPermissionData {
    /**
     * 
     * @type {string}
     * @memberof FieldPermissionData
     */
    resourceType?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldPermissionData
     */
    action?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof FieldPermissionData
     */
    requestedFields?: Set<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof FieldPermissionData
     */
    allowedFields?: Set<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof FieldPermissionData
     */
    deniedFields?: Set<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FieldPermissionData
     */
    fieldPermissions?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Set<string>; }}
     * @memberof FieldPermissionData
     */
    fieldMapping?: { [key: string]: Set<string>; };
    /**
     * 
     * @type {Array<string>}
     * @memberof FieldPermissionData
     */
    creatableCaseTypes?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof FieldPermissionData
     */
    totalFieldPermissions?: number;
    /**
     * 
     * @type {number}
     * @memberof FieldPermissionData
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof FieldPermissionData
     */
    pageSize?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FieldPermissionData
     */
    hasNext?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldPermissionData
     */
    hasPrevious?: boolean;
}

/**
 * Check if a given object implements the FieldPermissionData interface.
 */
export function instanceOfFieldPermissionData(value: object): value is FieldPermissionData {
    return true;
}

export function FieldPermissionDataFromJSON(json: any): FieldPermissionData {
    return FieldPermissionDataFromJSONTyped(json, false);
}

export function FieldPermissionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldPermissionData {
    if (json == null) {
        return json;
    }
    return {
        
        'resourceType': json['resource_type'] == null ? undefined : json['resource_type'],
        'action': json['action'] == null ? undefined : json['action'],
        'requestedFields': json['requested_fields'] == null ? undefined : new Set(json['requested_fields']),
        'allowedFields': json['allowed_fields'] == null ? undefined : new Set(json['allowed_fields']),
        'deniedFields': json['denied_fields'] == null ? undefined : new Set(json['denied_fields']),
        'fieldPermissions': json['field_permissions'] == null ? undefined : json['field_permissions'],
        'fieldMapping': json['field_mapping'] == null ? undefined : json['field_mapping'],
        'creatableCaseTypes': json['creatable_case_types'] == null ? undefined : json['creatable_case_types'],
        'totalFieldPermissions': json['total_field_permissions'] == null ? undefined : json['total_field_permissions'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['page_size'] == null ? undefined : json['page_size'],
        'hasNext': json['has_next'] == null ? undefined : json['has_next'],
        'hasPrevious': json['has_previous'] == null ? undefined : json['has_previous'],
    };
}

export function FieldPermissionDataToJSON(json: any): FieldPermissionData {
    return FieldPermissionDataToJSONTyped(json, false);
}

export function FieldPermissionDataToJSONTyped(value?: FieldPermissionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resource_type': value['resourceType'],
        'action': value['action'],
        'requested_fields': value['requestedFields'] == null ? undefined : Array.from(value['requestedFields'] as Set<any>),
        'allowed_fields': value['allowedFields'] == null ? undefined : Array.from(value['allowedFields'] as Set<any>),
        'denied_fields': value['deniedFields'] == null ? undefined : Array.from(value['deniedFields'] as Set<any>),
        'field_permissions': value['fieldPermissions'],
        'field_mapping': value['fieldMapping'],
        'creatable_case_types': value['creatableCaseTypes'],
        'total_field_permissions': value['totalFieldPermissions'],
        'page': value['page'],
        'page_size': value['pageSize'],
        'has_next': value['hasNext'],
        'has_previous': value['hasPrevious'],
    };
}

